<template>
  <div class="yes-input">
    <label>
      <span class="yes-input__title">{{ title }}</span>
      <input
        v-if="type !== 'textarea'"
        ref="input"
        :type="type"
        class="yes-input__input"
        :placeholder="placeholder"
        :value="value"
        @input="handleInput"
      >
      <textarea
        v-else-if="type === 'textarea'"
        ref="textarea"
        :cols="cols"
        :rows="rows"
        class="yes-input__textarea"
        :placeholder="placeholder"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'YesInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    cols: {
      type: String,
      default: '30'
    },
    rows: {
      type: String,
      default: '6'
    }
  },
  computed: {
    nativeInputValue () {
      return this.value === null || this.value === undefined ? '' : String(this.value)
    }
  },
  methods: {
    setNativeInputValue () {
      const input = this.getInput()
      if (!input) { return }
      if (input.value === this.nativeInputValue) { return }
      input.value = this.nativeInputValue
    },
    handleInput (event) {
      if (event.target.value === this.nativeInputValue) { return }

      this.$emit('input', event.target.value)

      this.$nextTick(this.setNativeInputValue)
    },
    getInput () {
      return this.$refs.input || this.$refs.textarea
    }
  }
}
</script>

<style scoped lang="scss">
  .yes-input {
    .yes-input__title {
      display: block;
      width: 100%;
      font-family: "Rubik Medium", sans-serif;
      font-size: 18px;
      margin-bottom: .5rem;
    }
    .yes-input__input {
      width: 100%;
      border-radius: 4px;
      height: 46px;
      border: 1px solid rgba(0,0,0,.1);
      padding: 0 1rem;

      &:focus {
        outline: 2px solid #1A5CAC;
      }
    }
    .yes-input__textarea {
      width: 100%;
      border-radius: 4px;
      padding: 1rem;
      &:focus {
        outline: 2px solid #1A5CAC;
      }
    }
  }
</style>
